import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Subject } from 'rxjs';
import { ApiService } from './api.service';
import { API_CONSTANTS } from '../shared/constants/api';
import { UserService } from '../dashboard/user/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private miniCartValue = new BehaviorSubject<any>({});
  private syncWithIndexDB = new BehaviorSubject<any>({});
  private refreshSalesman = new Subject<void>();
  refreshSalesman$ = this.refreshSalesman.asObservable();
  constructor(
    private apiService: ApiService,
    private userService: UserService
  ) { }
  
  validateAddress(payload: any = {}) {
    const endpoint = API_CONSTANTS.virtualServicesAddressValidate.replace(
      "{userId}",
      (this.userService.getUserEmail() || "").toLowerCase()
    );
    return this.apiService
      .post(endpoint, payload)
      .pipe(map(({ body }: any) => body));
  }

  setMiniCartValue(dataList: any) {
    this.miniCartValue.next(dataList);
  }

  getMiniCartValue() {
    return this.miniCartValue.asObservable();
  }

  setSyncWithIndexDB(value: any) {
    this.syncWithIndexDB.next(value);
  }

  getSetSyncWithIndexDB() {
    return this.syncWithIndexDB.asObservable();
  }

  getOrgCustomers(data: any = {}) {
    const endpoint = API_CONSTANTS.getOrgCustomers
      .replace("{userId}", data.userId)
      .replace("{accoundUid}", data.accoundUid);
    return this.apiService.get(endpoint).pipe(map(({ body }) => body));
  }
  private headerUpdateSubject = new Subject<void>();

  triggerHeaderUpdate() {
    this.headerUpdateSubject.next();
  }

  onHeaderUpdate() {
    return this.headerUpdateSubject.asObservable();
  }

  getDefaultUnit(data: any = {}) {
    const endpoint = API_CONSTANTS.getDefaultUnit
      .replace("{userId}", data.userId);
    return this.apiService.get(endpoint).pipe(map(({ body }) => body));
  }

  triggerSalesmanDashboardRefresh() {
    this.refreshSalesman.next();
  }
}
